import React, { useEffect, useRef, useState } from "react";
import UtilityHelper from "../utilities/UtilityHelper";
import { AlertMesage } from "../../widget/common/ui/Alerts";
import { textCase } from "../ui/UI";

type AudioRecorderType = {
  playButton: React.ReactNode;
  stopButton?: React.ReactNode;
  isCancel?: boolean;
  callbackStatus?: (status: boolean) => void;
  captureAudioRecorded: (val: File | null) => void;
};

const AudioRecorder: React.FC<AudioRecorderType> = ({
  playButton,
  stopButton,
  callbackStatus,
  captureAudioRecorded,
  isCancel = false,
}) => {
  stopButton = UtilityHelper.isNodeEmpty(stopButton) ? playButton : stopButton;

  const [isRecording, setIsRecording] = useState<boolean>(false);
  //const [audioURL, setAudioURL] = useState<string | null>(null);

  const isRecordingRef = useRef<boolean>(false);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const streamRef = useRef<MediaStream | null>(null);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (e: BlobEvent) => {
        audioChunksRef.current.push(e.data);
      };

      const mimeType = "audio/aac"; // or "audio/mp4" // "audio/webm
      mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: mimeType,
        });
        //const url = URL.createObjectURL(audioBlob);
        //setAudioURL(url);

        console.log(isRecordingRef.current);
        if (
          typeof captureAudioRecorded === "function" &&
          isRecordingRef.current
        ) {
          //  "recording.webm"
          const file = new File([audioBlob], "recording_audio_file.aac", {
            type: "video/webm",
            lastModified: Date.now(),
          });
          captureAudioRecorded(file);

          isRecordingRef.current = false;
        }

        // optional: upload audioBlob to server here
      };

      mediaRecorder.start();
      setIsRecording(true);
      isRecordingRef.current = true;

      if (typeof callbackStatus === "function") {
        callbackStatus(true);
      }
    } catch (err) {
      console.error("Microphone access denied or error:", err);
      AlertMesage({
        title: textCase("Microphone access denied or error"),
      });
    }
  };

  const cancelStopRecording = () => {
    mediaRecorderRef.current?.stop();
    streamRef.current?.getTracks().forEach((track) => track.stop());
    setIsRecording(false);

    isRecordingRef.current = false;
  };

  const stopRecording = () => {
    mediaRecorderRef.current?.stop();
    streamRef.current?.getTracks().forEach((track) => track.stop());

    //isRecordingRef.current = false;
    setIsRecording(false);

    if (typeof callbackStatus === "function") {
      callbackStatus(false);
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    isRecordingRef.current = false;

    return () => {
      isRecordingRef.current = false;
      streamRef.current?.getTracks().forEach((track) => track.stop());
    };
  }, []);

  useEffect(() => {
    if (isCancel) {
      cancelStopRecording();
    }
  }, [isCancel]);

  return (
    <div>
      {!isRecording ? (
        <span role="button" onClick={startRecording}>
          {playButton}
        </span>
      ) : (
        <span role="button" onClick={stopRecording}>
          {stopButton}
        </span>
      )}

      {/* {!isRecording ? (
        <button onClick={startRecording}>🎙 Start Recording</button>
      ) : (
        <button onClick={stopRecording}>⏹ Stop Recording</button>
      )}

      {audioURL && (
        <div style={{ marginTop: 20 }}>
          <h3>Recorded Audio:</h3>
          <audio controls src={audioURL} />
        </div>
      )} */}
    </div>
  );
};

export default AudioRecorder;
